import { useEffect, useState } from "react";
import styles from "../styles.module.css";
import { Select, Option } from "../../../select";

export default function Authentication({
  authentication,
  onChange,
  apiId,
  appId,
}) {
  const [type, setType] = useState("");
  useEffect(() => {
    if (authentication) {
      setType(authentication.type);
    } else {
      setType("");
    }
  }, [authentication]);

  const handleChange = (v) => {
    if (v) {
      const auth = { ...authentication };
      auth.type = v;
      console.log(auth);
      setType(v);
      onChange(auth);
    } else {
      onChange(null);
      setType(v);
    }
  };
  return (
    <div className={styles.section}>
      <div className={styles.sectionTitle}>Authentication</div>
      <Select
        style={{ fontSize: 14, marginTop: 12 }}
        value={type}
        onChange={handleChange}
      >
        <Option value={""}>none</Option>
        <Option value="Oauth2.0">Oauth 2.0</Option>
      </Select>
      {type === "Oauth2.0" && (
        <Oauth20
          onChange={onChange}
          appId={appId}
          apiId={apiId}
          authentication={authentication}
        />
      )}
    </div>
  );
}

const Oauth20 = ({ authentication, onChange, appId, apiId }) => {
  const [_auth, setAuth] = useState(authentication || {});
  const handleChange = (key, value) => {
    const auth = { ..._auth };
    auth[key] = value;
    setAuth(auth);
  };

  useEffect(() => {
    if (authentication) {
      setAuth(authentication);
    } else {
      setAuth({});
    }
  }, [authentication]);

  const handleSave = () => {
    onChange(_auth);
  };

  const verifyOauth = () => {
    window.open(
      `${_auth.login_url}?response_type=code&scope=${_auth.scope}&client_id=${_auth.client_id}&redirect_uri=http://localhost:5001/deft-cef16/us-central1/verifyoauth/${appId}/${apiId}`
    );
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", marginTop: 20 }}>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>App/Client ID</div>
          <input
            value={_auth.client_id}
            onChange={(e) => handleChange("client_id", e.target.value)}
            onBlur={handleSave}
            className="input"
          />
        </div>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>App/Client Secret</div>
          <input
            value={_auth.client_secret}
            onChange={(e) => handleChange("client_secret", e.target.value)}
            onBlur={handleSave}
            className="input"
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 12 }}>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>Scope</div>
          <input
            className="input"
            value={_auth.scope}
            onChange={(e) => handleChange("scope", e.target.value)}
            onBlur={handleSave}
          />
        </div>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>Token Name</div>
          <input
            className="input"
            value={_auth.token_name}
            onChange={(e) => handleChange("token_name", e.target.value)}
            onBlur={handleSave}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 12 }}>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>Login redirect URL</div>
          <input
            className="input"
            value={_auth.login_url}
            onChange={(e) => handleChange("login_url", e.target.value)}
            onBlur={handleSave}
          />
        </div>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>Access Token URL/endpoint</div>
          <input
            className="input"
            value={_auth.token_url}
            onChange={(e) => handleChange("token_url", e.target.value)}
            onBlur={handleSave}
          />
        </div>
      </div>
      <div style={{ display: "flex", marginTop: 12 }}>
        <div style={{ flexGrow: 4, margin: 4 }}>
          <div className={styles.headerTitle}>User Profile URL/endpoit</div>
          <input
            className="input"
            value={_auth.user_url}
            onChange={(e) => handleChange("user_url", e.target.value)}
            onBlur={handleSave}
          />
        </div>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>User ID Path</div>
          <input
            className="input"
            value={_auth.user_id_path}
            onChange={(e) => handleChange("user_id_path", e.target.value)}
            onBlur={handleSave}
          />
        </div>
        <div style={{ flexGrow: 1, margin: 4 }}>
          <div className={styles.headerTitle}>User Email Path</div>
          <input
            className="input"
            value={_auth.user_email_path}
            onChange={(e) => handleChange("user_email_path", e.target.value)}
            onBlur={handleSave}
          />
        </div>
      </div>
      <div
        className={
          _auth.test_token
            ? styles.iconButton + " " + styles.verified
            : styles.iconButton
        }
        onClick={verifyOauth}
      >
        {_auth.test_token ? "re-verify" : "Verify"}
      </div>
      {_auth.test_token && (
        <div>
          The calls bellow are being tested with the following API Token:
          <div
            style={{
              padding: 8,
              borderRadius: 8,
              backgroundColor: "#f2f2f2",
              overflowY: "scroll",
              whiteSpace: "nowrap",
            }}
          >
            {_auth.test_token}
          </div>
        </div>
      )}
    </div>
  );
};
